import React from 'react';

const Aboutus = () => {
    return (
        <div className='mt-5'>
            
        </div> 
    );
};

export default Aboutus;